<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/userBalance/availableFilBalance/summary/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      width="120"
      prop="date"
      label="时间">
    </el-table-column>
    <el-table-column
      prop="availableBalance"
      label="节点可用FIL">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.availableBalance),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="owner"
      label="owner(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.owner),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="worker"
      label="worker(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.worker),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="control"
      label="control(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.control),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="hicoinBalance"
      label="app充提(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.hicoinBalance),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="binanceBalance"
      label="币安(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.binanceBalance,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="summary"
      label="总计(FIL)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.summary,4)}}</span>
      </template>
    </el-table-column>
    <!-- <el-table-column fixed="right" label="操作" align="center" prop="time" width="100">
      <template slot-scope="scope">
         <el-button size="mini" type="primary"  v-if="scope.row.editable"><i class="el-icon-edit" style="margin-right:3px;"></i>编辑</el-button>
      </template>
    </el-table-column> -->
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime: '',
        endTime: '',
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.summaryList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
